export const PXBanner = (function () {
	'use strict';

	function init() {
		const $carousels = document.querySelectorAll("[data-banner-carousel]")
		for (let i = 0; i < $carousels.length; i++) {
			const $carousel = $carousels[i]
			const $previous = $carousel.querySelector('[data-banner-carousel-button="previous"]')
			const $next = $carousel.querySelector('[data-banner-carousel-button="next"]')
			const $slides = $carousel.querySelectorAll(".slide")
			const slideCount = $slides.length
			let slideIndex = 1
			const prevSlide = () => {
				slideIndex = slideIndex > 1 ? slideIndex - 1 : slideCount
				$carousel.setAttribute('data-banner-carousel-direction', 'back')
				$carousel.setAttribute('data-banner-carousel', slideIndex)
			}
			const nextSlide = () => {
				slideIndex = slideIndex + 1 > slideCount ? 1 : slideIndex + 1
				$carousel.setAttribute('data-banner-carousel-direction', 'forward')
				$carousel.setAttribute('data-banner-carousel', slideIndex)
			}
			$previous && $previous.addEventListener('click', prevSlide)
			$next && $next.addEventListener('click', nextSlide)
		}
		$('.slider--video').each( function() {
			var height = $(this).parent().height();
			var ratio = height * 100 / 56.25;
			$(this).width(ratio);
		});
	}

	return {
		init: init,
		name: 'banner',
	};
})();
